var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "archive"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2267_771",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2267_771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "archive_2",
    d: "M12 10.2885C11.7872 10.2885 11.609 10.3603 11.4654 10.5039C11.3218 10.6475 11.25 10.8257 11.25 11.0385V14.7385L9.92688 13.4154C9.78842 13.2769 9.61439 13.2061 9.40478 13.2029C9.19518 13.1997 9.01794 13.2705 8.87308 13.4154C8.72819 13.5603 8.65575 13.7359 8.65575 13.9423C8.65575 14.1487 8.72819 14.3243 8.87308 14.4692L11.3673 16.9634C11.5481 17.1442 11.759 17.2346 12 17.2346C12.241 17.2346 12.4519 17.1442 12.6327 16.9634L15.1269 14.4692C15.2653 14.3308 15.3362 14.1567 15.3394 13.9471C15.3426 13.7375 15.2718 13.5603 15.1269 13.4154C14.982 13.2705 14.8064 13.1981 14.6 13.1981C14.3936 13.1981 14.2179 13.2705 14.0731 13.4154L12.75 14.7385V11.0385C12.75 10.8257 12.6782 10.6475 12.5346 10.5039C12.391 10.3603 12.2128 10.2885 12 10.2885ZM4.99997 7.90385V18.6923C4.99997 18.782 5.02883 18.8558 5.08653 18.9135C5.14423 18.9712 5.21795 19 5.3077 19H18.6923C18.782 19 18.8557 18.9712 18.9134 18.9135C18.9711 18.8558 19 18.782 19 18.6923V7.90385H4.99997ZM5.38463 20.5C4.88591 20.5 4.44712 20.3106 4.06827 19.9317C3.68942 19.5529 3.5 19.1141 3.5 18.6154V7.0058C3.5 6.7917 3.5343 6.58753 3.6029 6.3933C3.67148 6.19908 3.77437 6.01992 3.91155 5.85582L5.3154 4.15773C5.4795 3.94363 5.68462 3.78048 5.93077 3.6683C6.17692 3.55612 6.43718 3.50002 6.71155 3.50002H17.2692C17.5435 3.50002 17.8054 3.55612 18.0547 3.6683C18.3041 3.78048 18.5108 3.94363 18.6749 4.15773L20.0884 5.87505C20.2256 6.03915 20.3285 6.21992 20.3971 6.41735C20.4657 6.61478 20.5 6.82055 20.5 7.03465V18.6154C20.5 19.1141 20.3105 19.5529 19.9317 19.9317C19.5528 20.3106 19.114 20.5 18.6153 20.5H5.38463ZM5.39035 6.40388H18.6L17.5096 5.10578C17.4775 5.07373 17.4407 5.04808 17.399 5.02885C17.3573 5.00962 17.314 5 17.2692 5H6.72117C6.67629 5 6.63302 5.00962 6.59135 5.02885C6.54968 5.04808 6.51282 5.07373 6.48075 5.10578L5.39035 6.40388Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.a6328a10150421f67414c3634e2190b8.svg";
export { ForwardRef as ReactComponent };